import { Link } from '../components/ui'

export default { Link }
